import { flow, isArray, mapValues } from 'lodash';

export interface DynamicComponentDefinition {
  component: any;
  inputs?: Record<string, any>;
  outputs?: Record<string, ($event: any) => any>;
  hide?: boolean;
}

export function pipeDynamicComponentOutputs(
  definition: DynamicComponentDefinition,
  fnWrapper: Array<(output: any) => any> | ((output: any) => any)
): DynamicComponentDefinition {
  const fns = isArray(fnWrapper) ? fnWrapper : [fnWrapper];
  return {
    ...definition,
    outputs: mapValues(definition.outputs, (outputFn) =>
      flow([outputFn, ...fns])
    ),
  };
}
